import { Plugin } from '@ckeditor/ckeditor5-core';
import RecorderBlock from './recorderblock';
import RecorderInline from './recorderinline';
import RecorderUI from './recorderui';
import RecorderAudioCommand from './recorderaudiocommand';
import RecorderVideoCommand from './recordervideocommand';
import './theme/recorder.css';

export default class Recorder extends Plugin {
    /**
     * @inheritDoc
     */
    static get requires() {
        return [ RecorderBlock, RecorderUI ];
    }

    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'Recorder';
    }

    init() {
        const editor = this.editor;

        //  Registrar comandos personalizados
        editor.commands.add('recordAudio', new RecorderAudioCommand(editor));
        editor.commands.add('recordVideo', new RecorderVideoCommand(editor));
    }
}
